import gql from 'graphql-tag';
import { RequestsFragment } from '@app/pages/cmms/graphql/requests.queries';

export const CreateRequest = gql`
	mutation CreateRequest(
		$approver: UUID
		$approverType: UserGroupEnum
		$assignee: UUID
		$assigneeType: UserGroupEnum
		$categories: [String]
		$category: RequestCategories
		$description: String!
		$name: String!
		$priority: Int
		$files: [UUID]
		$incidents: [UUID]
		$workOrders: [UUID]
		$locations: [LocationInput]
		$assets: [AssetInput]
		$labels: [UUID]
		$requestees: [RequesterInput]
	) {
		createRequest(
			approver: $approver
			approverType: $approverType
			assignee: $assignee
			assigneeType: $assigneeType
			categories: $categories
			category: $category
			description: $description
			name: $name
			priority: $priority
			files: $files
			incidents: $incidents
			workOrders: $workOrders
			locations: $locations
			assets: $assets
			labels: $labels
			requestees: $requestees
		) {
			success
			request {
				...RequestsFragment
			}
		}
	}
	${RequestsFragment}
`;

export const EditRequest = gql`
	mutation EditRequest(
		$approver: UUID
		$approverType: UserGroupEnum
		$assignee: UUID
		$assigneeType: UserGroupEnum
		$categories: [String]
		$category: RequestCategories
		$description: String!
		$name: String!
		$pk: UUID!
		$priority: Int
		$status: RequestStatus
		$files: [UUID]
		$incidents: [UUID]
		$workOrders: [UUID]
		$locations: [LocationInput]
		$assets: [AssetInput]
		$labels: [UUID]
		$requestees: [RequesterInput]
	) {
		editRequest(
			approver: $approver
			approverType: $approverType
			assignee: $assignee
			assigneeType: $assigneeType
			categories: $categories
			category: $category
			description: $description
			name: $name
			pk: $pk
			priority: $priority
			status: $status
			files: $files
			incidents: $incidents
			workOrders: $workOrders
			locations: $locations
			assets: $assets
			labels: $labels
			requestees: $requestees
		) {
			success
			request {
				...RequestsFragment
			}
		}
	}
	${RequestsFragment}
`;

export const DeleteRequest = gql`
	mutation DeleteRequest($pk: UUID!) {
		deleteRequest(pk: $pk) {
			success
		}
	}
`;

export const DeleteRequests = gql`
	mutation DeleteRequests($requests: [UUID]!) {
		deleteRequests(requests: $requests) {
			success
		}
	}
`;

export const UnlinkRequestObjects = gql`
	mutation UnlinkRequestObjects($pk: UUID!, $incidents: [UUID], $workOrders: [UUID]) {
		unlinkRequestObjects(pk: $pk, incidents: $incidents, workOrders: $workOrders) {
			success
		}
	}
`;

export const LinkRequestsMutation = gql`
	mutation (
		$requests: [UUID!]!
		$status: RequestStatus
		$priority: Int
		$category: RequestCategories
		$workOrders: [UUID!]
		$incidents: [UUID!]
		$labels: [UUID!]
	) {
		linkRequests(
			requests: $requests
			status: $status
			priority: $priority
			category: $category
			workOrders: $workOrders
			incidents: $incidents
			labels: $labels
		) {
			success
		}
	}
`;
